'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _FormInput = require('../FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

function mapStateToProps(state) {
    return {
        cart: state.cart
    };
}

var mapDispatchToProps = {
    setCartNote: _actions2.default.setCartNote
};

var Note = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(Note, _React$PureComponent);

    function Note() {
        (0, _classCallCheck3.default)(this, Note);
        return (0, _possibleConstructorReturn3.default)(this, (Note.__proto__ || (0, _getPrototypeOf2.default)(Note)).apply(this, arguments));
    }

    (0, _createClass3.default)(Note, [{
        key: 'changeNote',
        value: function changeNote(note) {
            this.props.setCartNote(note);
        }
    }, {
        key: 'createInput',
        value: function createInput(field, label, isRequired, className, maxLength) {
            var _this2 = this;

            var cart = this.props.cart;


            return _react2.default.createElement(_FormInput2.default, {
                name: field,
                value: cart[field],
                label: label,
                isRequired: isRequired,
                className: className,
                maxLength: maxLength,
                onChange: function onChange(e) {
                    return _this2.changeNote(e.target.value);
                } });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'row' },
                this.createInput('note', Resx.App.OrderNote, false, 'col-sm-12', 500)
            );
        }
    }]);
    return Note;
}(_react2.default.PureComponent), _class2.propTypes = {
    cart: _propTypes2.default.object,
    setCartNote: _propTypes2.default.func
}, _temp)) || _class);
exports.default = Note;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/Note.js
// module id = 752
// module chunks = 0